import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteArqueacao,
  findArqueacao,
  recordFiltering,
} from '~/store/modules/arqueacao/actions';

import Form from './form';

function ArqueacaoList() {
  const redux = useSelector((state) => state.arqueacao);

  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },
      {
        id: 'nomearqueacao',
        label: t('s.configuracao.arqueacao.nomearqueacao'),
        filter: { type: 'text' },
      },
      {
        id: 'alturamaximaarqueacao',
        label: t('s.configuracao.arqueacao.alturamaximaarqueacao'),
      },
      {
        id: 'volumemaximoarqueacao',
        label: t('s.configuracao.arqueacao.volumemaximoarqueacao'),
      },
    ],
    []
  );

  const fieldlist = [
    'codigonomeposto',
    'nomearqueacao',
    'alturamaximaarqueacao',
    'volumemaximoarqueacao',
  ];

  const substituirHeader = {
    codigonomeposto: t('s.geral.postocomboio'),
    nomearqueacao: t('s.configuracao.arqueacao.nomearqueacao'),
    alturamaximaarqueacao: t('s.configuracao.arqueacao.alturamaximaarqueacao'),
    volumemaximoarqueacao: t('s.configuracao.arqueacao.volumemaximoarqueacao'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findArqueacao}
      remove={deleteArqueacao}
      form={Form}
      keys={['idarqueacao', 'idposto']}
      detach="idarqueacao"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'arqueacoes',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Arqueações',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
        })
      }
    />
  );
}

export default ArqueacaoList;
